export const getSellerCompanyCode = (fields) => {
  const sellerCompanyCodeExists =
    Object.keys(fields).length !== 0 && "sellerCompanyCode" in fields;
  return sellerCompanyCodeExists ? fields.sellerCompanyCode.value : "";
};



// WEBPACK FOOTER //
// ./src/utils/cbotUtils.js